import * as React from 'react';
import LandingPage from '../landing-v2/LandingPage';

export default function index() {
  return <LandingPage />;
}
